// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Localization

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function TempElementLocalesItem(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'TempElementLocalesItem',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: 'currentColor',
      d: 'M5 10.898C2.729 10.43 1 8.401 1 6c0-2.743 2.257-5 5-5 2.401 0 4.43 1.729 4.898 4H6.525a.43.43 0 00.127-.09c.435-.434-.216-1.086-.216-1.086.434-.653.216-1.74.216-1.74-1.086-.215-3.695 0-3.695 2.174 0 1.519 1.275 1.977 2.043 2.114v4.526zM6 9h5V8H6v1zm-.907-4c.156-.285.473-.524.473-.524s.305.405.635.524H5.093z',
    }),
    createElement('path', {
      opacity: '.4',
      fill: 'currentColor',
      d: 'M6 6v1h5V6H6zm0 5h5v-1H6v1z',
    })
  );
}
